import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_safe_area_debug';

const readInitialValue = (): boolean => {
	try {
		return localStorage.getItem(STORAGE_KEY) === 'true';
	} catch {
		return false;
	}
};

/** When true, shows the on-device safe-area debug overlay (top/bottom rulers + metrics panel). */
export const safeAreaDebugEnabled = writable<boolean>(readInitialValue());

safeAreaDebugEnabled.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isSafeAreaDebugEnabled = (): boolean => get(safeAreaDebugEnabled);

export const setSafeAreaDebugEnabled = (enabled: boolean) => {
	safeAreaDebugEnabled.set(enabled);
};
